import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { LobbyComponent } from './lobby/lobby.component';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import {
  reducer, joinDarftMiniLobbyReducer, gamePositionFilters, bestBallPickedCount, joinTournamentMiniLobbyReducer, soundOnOff, userDraftTurn,
  setDeafultRank, pickedPlayerList, currentPickNumber, playersListReducer, changeInDraft, currTournamentData, mobileScreenData, anthUserData, positionsRemovedData, isAutoDraftEnable, byeWeekList,DarkModeReducer, userBalanceData
} from './store/reducers/appReducers';
import { leaguereducer, draftReducer, draftScoreReducer, myTeamReducer, rosterPositionReducer, leagueScoreReducer } from './store/reducers/appReducers';

import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { CountdownModule } from 'ngx-countdown';
import { HeaderComponent } from './components/header/header.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PapaParseModule } from 'ngx-papaparse';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainService } from './_services/main.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EmojisModule } from 'ng2-emojis';
import { Ng2EmojiModule } from 'ng2-emoji';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { NgxPayPalModule } from 'ngx-paypal';
import { AngularResizedEventModule } from 'angular-resize-event';

import { fakeBackendProvider } from './_helpers';
import { AlertComponent } from './_directives';
import { AuthGuard,UnSavedGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AlertService, AuthenticationService, UserService } from './_services';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { RegisterComponent } from './register';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { AddfundPopupComponent } from './addfund-popup/addfund-popup.component';
import { LeagueRegPopupComponent } from './league-reg-popup/league-reg-popup.component';
import { TournamentpopupComponent } from 'src/app/tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from 'src/app/gamepreviewpopup/gamepreviewpopup.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { DefaultRankPopupComponent } from './default-rank-popup/default-rank-popup.component';
import { RosterspopupComponent } from './rosterspopup/rosterspopup.component';
import { ModalService } from 'src/app/_services/modal.service';
import { PlayerinfoboxComponent } from 'src/app/playerinfobox/playerinfobox.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { SortablejsModule } from 'angular-sortablejs';
import { LeagueInviteComponent } from './components/league-invite/league-invite.component';
import { AddMessageComponent } from './add-message/add-message.component';
import { InviteFriendsComponent } from './components/invite-friends/invite-friends.component';
import { ChatAdapterHistory } from './_services/chat-adapter';
import { NgChatModule } from 'ng-chat';
import { MatTooltipModule, MatCardModule, MatSnackBarModule } from '@angular/material';
import { MobileInfoboxComponent } from './components/mobile-infobox/mobile-infobox.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { ErrorsModule } from './errors/errors.module';
import { FaqComponent } from './faq/faq.component';
import { FilterTitlesPipe } from './faq/filterTitles.pipe';
import { OwnershipComponent } from './pages/ownership/ownership.component';
import { SharedModule } from './components/shared.module';
import { ResponsibleComponent } from './pages/responsible/responsible.component';
import { ResponsibleConfirmComponent } from './pages/responsible-confirm/responsible-confirm.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GameSelectorComponent } from './game-selector/game-selector.component';
import { LobbyFiltersComponent } from './lobby-filters/lobby-filters.component';
import { SameHeightDirective } from './_directives/same-height.directive';
import { RankingsComponent } from './rankings/rankings.component';
import { RankingsImportComponent } from './rankings/rankings-import.component';
import { RoasterConstructionComponent } from "./rankings/roaster-construction.component";
import { RankingOverwriteComponent } from './rankings/ranking-overwrite.component';
import { NewsfeedComponent } from './newsfeed/newsfeed.component';
import { PostboxComponent } from './postbox/postbox.component';
import { PollsComponent } from './polls/polls.component';
import { GiphyComponent } from './giphy/giphy.component';
import { TiersComponent } from './tiers/tiers.component';
import { CallbackPipe } from './tiers/callback.pipe';
import { PricePipe } from './price.pipe';
import { Draft2Component } from './draft2/draft2.component';
import { Playerinfobox2Component } from './playerinfobox2/playerinfobox2.component';
import { DraftchatComponent } from './draftchat/draftchat.component';
import { ActiveDrafts2Component } from './active-drafts2/active-drafts2.component';
import { MyteamsComponent } from './myteams/myteams.component';
import { ConfirmDropComponent } from './confirm-drop/confirm-drop.component';
import { NfpageComponent } from './newsfeed/nfpage.component';
import { StandingsComponent } from './standings/standings.component';
import { DraftStartingComponent } from './draft-starting/draft-starting.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MessagesComponent } from './messages/messages.component';
import { SmartAppBannerComponent } from './components/smart-app-banner/smart-app-banner.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { VerificationComponent } from './verification/verification.component';
import { PropsComponent } from './props/props.component';
import { PropsTopBarComponent } from './props-top-bar/props-top-bar.component';
import { MyteamComponent } from './props/myteam/myteam.component';
import { UsersComponent } from './users/users.component';
import { LeftSideComponent } from './users/leftSide/leftSide.component';
import { RightSideComponent } from './users/rightSide/rightside.component';
import { RankemComponent } from './rankem/rankem.component';
import { WeekMetrixComponent } from './weekMetrix/weekMetrix.component';
import { SwapPlayersComponent } from './swapPlayers/swapPlayers.component';
import { MultiSwapPlayersComponent } from './multiSwapPlayers/multiSwapPlayers.component' 
import { MatchupComponent } from './matchup/matchup.component';
import { FirstTimeDepositComponent } from './card-payment/first-time-deposit/first-time-deposit.component';
import { SaveCardPaymentComponent } from './card-payment/save-card-payment/save-card-payment.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { PaypalButtonComponent } from './paypal-button/paypal-button.component';
import { ApplePayButtonComponent } from './apple-pay-button/apple-pay-button.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    AlertComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    TournamentpopupComponent,
    GamepreviewpopupComponent,
    AddfundPopupComponent,
    LeagueRegPopupComponent,
    DefaultRankPopupComponent,
    RosterspopupComponent,
    PlayerinfoboxComponent,
    ConfirmboxComponent,
    LeagueInviteComponent,
    AddMessageComponent,
    InviteFriendsComponent,
    MobileInfoboxComponent,
    DraftchatComponent,
    FaqComponent,
    OwnershipComponent,
    ResponsibleComponent,
    ResponsibleConfirmComponent,
    LobbyComponent,
    FilterTitlesPipe,
    PricePipe,
    GameSelectorComponent,
    LobbyFiltersComponent,
    SameHeightDirective,
    RankingsComponent,
    RankingsImportComponent,
    RoasterConstructionComponent,
    RankingOverwriteComponent,
    NewsfeedComponent,
    PostboxComponent,
    PollsComponent,
    GiphyComponent,
    TiersComponent,
    CallbackPipe,
    Draft2Component,
    Playerinfobox2Component,
    DraftchatComponent,
    ActiveDrafts2Component,
    MyteamsComponent,
    ConfirmDropComponent,
    NfpageComponent,
    StandingsComponent,
    DraftStartingComponent,
    MessagesComponent,
    SmartAppBannerComponent,
    PhoneVerificationComponent,
    VerificationComponent,
    PropsComponent,
    PropsTopBarComponent,
    MyteamComponent,
    UsersComponent,
    LeftSideComponent,
    RightSideComponent,
    RankemComponent,
    WeekMetrixComponent,
    SwapPlayersComponent,
    MultiSwapPlayersComponent,
    MatchupComponent,
    FirstTimeDepositComponent,
    SaveCardPaymentComponent,
    WelcomeComponent,
    PaypalButtonComponent,
    ApplePayButtonComponent
  ],
  imports: [
    PapaParseModule,
    MatSliderModule,
    MatBadgeModule,
    MatProgressBarModule,
    MatCardModule,
    MatSnackBarModule,
    MatListModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    PerfectScrollbarModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatDialogModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    MatTooltipModule,
    CountdownModule,
    NgxSpinnerModule,
    EmojisModule,
    NgxPayPalModule,
    CreditCardDirectivesModule,
    AngularResizedEventModule,
    NgChatModule,
    FlashMessagesModule.forRoot(),
    Ng2EmojiModule.forRoot(),
    SortablejsModule.forRoot({ animation: 150, scrollSpeed: 75 }),
    DeviceDetectorModule.forRoot(),
    TooltipModule,
    StoreModule.forRoot({
      user: reducer,
      resultboard_draft: leaguereducer,
      league_draft: draftReducer,
      league_score_draft: draftScoreReducer,
      my_team_data: myTeamReducer,
      roster_position_data: rosterPositionReducer,
      league_score: leagueScoreReducer,
      join_darft_mini_lobby: joinDarftMiniLobbyReducer,
      tournament_mini_lobby: joinTournamentMiniLobbyReducer,
      game_position_filers: gamePositionFilters,
      best_ball_picked_count: bestBallPickedCount,
      sound_toggle: soundOnOff,
      set_default_rank: setDeafultRank,
      draft_turn: userDraftTurn,
      picked_players: pickedPlayerList,
      current_pick_number: currentPickNumber,
      players_list: playersListReducer,
      changeInCurrentDraft: changeInDraft,
      curr_tournament_data: currTournamentData,
      isMobileScreen: mobileScreenData,
      authData: anthUserData,
      userBalance: userBalanceData,
      positionsRemoved: positionsRemovedData,
      isAutoDraftEnable: isAutoDraftEnable,
      byeWeekList: byeWeekList,
      DarkModeReducer:DarkModeReducer
    }),
    PickerModule,
    SharedModule,
    ErrorsModule,
    MatSlideToggleModule
  ],
  providers: [
    MainService,
    AuthGuard,
    UnSavedGuard,
    AlertService,
    AuthenticationService,
    UserService,
    TournamentService,
    DatePipe,
    ModalService,
    CurrencyPipe,
    CallbackPipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    fakeBackendProvider
  ],
  entryComponents: [
    TournamentpopupComponent,
    GamepreviewpopupComponent,
    DraftStartingComponent,
    AddfundPopupComponent,
    LeagueRegPopupComponent,
    DefaultRankPopupComponent,
    RosterspopupComponent,
    PlayerinfoboxComponent,
    Playerinfobox2Component,
    ConfirmboxComponent,
    LeagueInviteComponent,
    AddMessageComponent,
    InviteFriendsComponent,
    MobileInfoboxComponent,
    ResponsibleConfirmComponent,
    FaqComponent,
    LobbyFiltersComponent,
    RankingsImportComponent,
    RankingOverwriteComponent,
    ConfirmDropComponent,
    PostboxComponent,
    PollsComponent,
    GiphyComponent,
    RoasterConstructionComponent,
    PhoneVerificationComponent,
    VerificationComponent,
    WeekMetrixComponent,
    SwapPlayersComponent,
    MultiSwapPlayersComponent,
    MatchupComponent,
    FirstTimeDepositComponent

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
